import React from 'react';
import { SearchFiltersDates } from './dates/SearchFiltersDates';
import { SearchFiltersCategory } from './categories/SearchFiltersCategory';
import { SearchFiltersOthers } from './others/SearchFiltersOthers';
import { Connect, PropsFromRedux } from './SearchFiltersBarDecisionContainer';
import { SearchDecisionWatcher } from '../search-watcher/SearchDecisionWatcher';
import { DatesSelectors } from '../aside-filters/dates/range-selection/DatesSelectors';
import {
  reportFilterToggle,
  filterActionTypes,
} from '../mobile-actions/filtersUtils';
import { SearchFiltersBarActions } from './SearchFiltersBarActions';
import { SearchFilterBarItem } from './SearchFilterBarItem';

type Props = PropsFromRedux;

const RawSearchFiltersBarDecision: React.FunctionComponent<Props> = ({
  shouldDisplayDomaine,
  shouldDisplayJuridiction,
  hasDateSelected,
  hasJurisdictionSelected,
  hasDomaineSelected,
  dateLabel,
  jurisdictionCount,
  domaineCount,
  otherCount,
  type,
}) => {
  function track(actionType: filterActionTypes, value: boolean) {
    reportFilterToggle(type, actionType, value);
  }

  return (
    <>
      <SearchFilterBarItem>
        <SearchFiltersDates
          label={dateLabel}
          isSelected={hasDateSelected}
          track={track}
        >
          <DatesSelectors type="decision" />
        </SearchFiltersDates>
      </SearchFilterBarItem>

      {shouldDisplayJuridiction && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            position={-50}
            count={jurisdictionCount}
            isSelected={hasJurisdictionSelected}
            type="juridiction"
            track={track}
            searchType="arret"
          />
        </SearchFilterBarItem>
      )}
      {shouldDisplayDomaine && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            position={-150}
            count={domaineCount}
            type="domaine"
            isSelected={hasDomaineSelected}
            track={track}
            searchType="arret"
          />
        </SearchFilterBarItem>
      )}
      <SearchFilterBarItem>
        <SearchFiltersOthers count={otherCount} track={track} />
      </SearchFilterBarItem>

      <SearchFiltersBarActions>
        <SearchDecisionWatcher />
      </SearchFiltersBarActions>
    </>
  );
};

export const SearchFiltersBarDecision = Connect(RawSearchFiltersBarDecision);
